import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfKeypad',
  standalone: false,
})
export class TypeOfKeypadPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: string): any {
    let type: string = '';

    switch (value) {
      case AppConst.KEYPAD_TYPE_TEXT:
        type = this.translate.instant('半角英数＋ハイフン');
        break;
      case AppConst.KEYPAD_TYPE_TEL:
      default:
        type = this.translate.instant('半角数字');
        break;
    }
    return type;
  }
}
